export const version = "bignumber/5.4.0";
